"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.push = void 0;

/**
 * Add element at end of array
 *
 * @param  {mixed}  element  Element to be added
 * @param  {Array}  input    Array to add to
 *
 * @return {Array}
 *
 * @tag Array
 * @signature (...elements: mixed) => (input: Array): Array
 *
 * @example
 * push(2)([1]) // => [1, 2]
 * push(2, 4)([1]) // => [1, 2, 4]
 */
var push = function push() {
  for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
    elements[_key] = arguments[_key];
  }

  return function (input) {
    return input.concat(elements);
  };
};

exports.push = push;